export function adicionaCarrinhoRequest(
  idCatalogo,
  idPagina,
  idItem,
  idMaterial,
  partnumber,
  quantidade = 1,
  codimate = null,
  imagemCatalogo,
  itemOS,
  codiAgente,
  codiMofa,
  codiSetr,
  codiSist,
  codiLoca
) {
  return {
    type: '@cart/ADD_REQUEST',
    idCatalogo,
    idPagina,
    idItem,
    idMaterial,
    partnumber,
    quantidade,
    codimate,
    imagemCatalogo,
    itemOS,
    codiAgente,
    codiMofa,
    codiSetr,
    codiSist,
    codiLoca,
  };
}

// export function adicionaCarrinhoRequest(itens) {
//   return {
//     type: '@cart/ADD_REQUEST',
//     payload: {
//       itens,
//     },
//   };
// }

export function adicionaCarrinhoArrayRequest(idCatalogo, arrayItens) {
  return {
    type: '@cart/ADD_ARRAY_REQUEST',
    idCatalogo,
    arrayItens,
  };
}

export function adicionaCarrinhoSuccess(item) {
  return {
    type: '@cart/ADD_SUCCESS',
    item,
  };
}

export function removeCarrinho(
  idCatalogo,
  idPagina,
  idItem,
  idMaterial,
  codimate = null
) {
  return {
    type: '@cart/REMOVE',
    idCatalogo,
    idPagina,
    idItem,
    idMaterial,
    codimate,
  };
}

export function limpaCarrinho() {
  return {
    type: '@cart/CLEAR',
  };
}

export function atualizaQuantidadeRequest(
  idCatalogo,
  idPagina,
  idItem,
  idMaterial,
  quantidade,
  codimate = null
) {
  return {
    type: '@cart/UPDATE_AMOUNT_REQUEST',
    idCatalogo,
    idPagina,
    idItem,
    idMaterial,
    quantidade: Number(quantidade),
    codimate,
  };
}

export function atualizaQuantidadeSuccess(
  idCatalogo,
  idPagina,
  idItem,
  idMaterial,
  quantidade,
  codimate
) {
  return {
    type: '@cart/UPDATE_AMOUNT_SUCCESS',
    idCatalogo,
    idPagina,
    idItem,
    idMaterial,
    quantidade: Number(quantidade),
    codimate,
  };
}

export function atualizaItemOSRequest(
  idCatalogo,
  idPagina,
  idItem,
  idMaterial,
  itemOS,
  codimate = null
) {
  return {
    type: '@cart/UPDATE_ITEMOS_REQUEST',
    idCatalogo,
    idPagina,
    idItem,
    idMaterial,
    itemOS,
    codimate,
  };
}

export function atualizaItemOSSuccess(
  idCatalogo,
  idPagina,
  idItem,
  idMaterial,
  itemOS,
  codimate
) {
  return {
    type: '@cart/UPDATE_ITEMOS_SUCCESS',
    idCatalogo,
    idPagina,
    idItem,
    idMaterial,
    itemOS,
    codimate,
  };
}

export function sharedManagementSet(set) {
  return {
    type: '@cart/SHARED_MANAGEMENT_SET',
    set,
  };
}
